const comments = [
  {
    id: 1,
    name: '追剧小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20portrait%20avatar%2C%20soft%20geometric%20shapes%2C%20terracotta%20and%20cream%20colors%2C%20simple%20illustration%20style%2C%20clean%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '被窝网电影真的太香了！《狂飙》全集一口气刷完，高清流畅完全没有卡顿，而且真的完全免费，良心平台！',
    drama: '在看《狂飙》',
    time: '2小时前',
  },
  {
    id: 2,
    name: '深夜剧迷',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20portrait%20avatar%2C%20soft%20rounded%20shapes%2C%20amber%20and%20warm%20beige%20colors%2C%20simple%20illustration%20style%2C%20clean%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '每天晚上躺床上就在被窝网上追《庆余年》第二季，更新速度超快，画质也是杠杠的，推荐给所有爱追剧的小伙伴！',
    drama: '在看《庆余年》',
    time: '5小时前',
  },
  {
    id: 3,
    name: '影视达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20portrait%20avatar%2C%20soft%20organic%20shapes%2C%20coral%20and%20cream%20colors%2C%20simple%20illustration%20style%2C%20clean%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '找了好久终于找到一个不用充会员就能看全集的网站了！被窝网的电视剧资源真的全，国产剧韩剧美剧啥都有。',
    drama: '在看《长安十二时辰》',
    time: '昨天',
  },
  {
    id: 4,
    name: '暖暖的被窝',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20portrait%20avatar%2C%20soft%20curved%20shapes%2C%20golden%20and%20cream%20colors%2C%20simple%20illustration%20style%2C%20clean%20background&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '被窝网电影名字起得太好了！冬天窝在被窝里追剧，简直不要太舒服。而且不缓冲这点是真的厉害，我网速一般也不卡。',
    drama: '在看《莲花楼》',
    time: '昨天',
  },
  {
    id: 5,
    name: '追剧不熬夜',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20abstract%20portrait%20avatar%2C%20soft%20circular%20shapes%2C%20warm%20brown%20and%20cream%20colors%2C%20simple%20illustration%20style%2C%20clean%20background&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '从被窝网电影追了《繁花》全集，沪语版和普通话版都有，太贴心了！现在每天都要来看看有没有新剧更新。',
    drama: '在看《繁花》',
    time: '2天前',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            追剧热评
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">追剧热评 · 剧迷真实声音</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">来看看大家都在追什么剧，分享你的追剧体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((c) => (
            <div key={c.id} className="bg-background-100 rounded-xl p-5 border border-background-200/70 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
              <div className="flex items-center gap-2 text-xs">
                <span className="px-2 py-1 rounded-md bg-accent-100 text-accent-700 font-medium">{c.drama}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}